import { Navigate, Route, Routes } from "react-router-dom";

import { Layout } from "./components/Layout.tsx";
import { RequireAuth } from "./components/RequireAuth.tsx";
import { Agents } from "./pages/Agents.tsx";
import { AgentProfile } from "./pages/AgentProfile.tsx";
import { Audit } from "./pages/Audit.tsx";
import { Businesses } from "./pages/Businesses.tsx";
import { BusinessProfile } from "./pages/BusinessProfile.tsx";
import { Chat } from "./pages/Chat.tsx";
import { Decisions } from "./pages/Decisions.tsx";
import { Digests } from "./pages/Digests.tsx";
import { Hosts } from "./pages/Hosts.tsx";
import { Settings } from "./pages/Settings.tsx";
import { Skills } from "./pages/Skills.tsx";
import { SkillProfile } from "./pages/SkillProfile.tsx";
import { Tools } from "./pages/Tools.tsx";
import { ToolProfile } from "./pages/ToolProfile.tsx";

export function App() {
	return (
		<Routes>
			<Route
				element={
					<RequireAuth>
						<Layout />
					</RequireAuth>
				}
			>
				<Route index element={<Chat />} />
				<Route path="/digests" element={<Digests />} />
				<Route path="/businesses" element={<Businesses />} />
				<Route path="/businesses/:id" element={<BusinessProfile />} />
				<Route path="/agents" element={<Agents />} />
				<Route path="/agents/:key" element={<AgentProfile />} />
				<Route path="/hosts" element={<Hosts />} />
				<Route path="/skills" element={<Skills />} />
				<Route path="/skills/:key" element={<SkillProfile />} />
				<Route path="/tools" element={<Tools />} />
				<Route path="/tools/:fullKey" element={<ToolProfile />} />
				<Route path="/decisions" element={<Decisions />} />
				<Route path="/audit" element={<Audit />} />
				<Route path="/settings" element={<Settings />} />
			</Route>
			<Route path="*" element={<Navigate to="/" replace />} />
		</Routes>
	);
}
